export default __webpack_public_path__ + "static/media/feature-backup-1.0cb49fda.png";